<template><section><template>
<h3>Uploader</h3>
<div class="bs-docs-section">
<div class="bs-example">
<h4>simplie file</h4>
<p><n3-uploader url="http://test.com/" :multiple="false" @error="onError" :max-size="0.5"></n3-uploader></p>
<hr>
<h4>click</h4>
<p><n3-uploader url="http://test.com/" @error="onError"></n3-uploader></p>
<hr>
<h4>drag</h4>
<p><n3-uploader type="drag" url="http://test.com/" @error="onError"></n3-uploader></p>
</div>
<pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-comment">&lt;!-- single file --&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">n3-uploader</span> <span class="hljs-attr">url</span>=<span class="hljs-string">"http://test.com/"</span> <span class="hljs-attr">:multiple</span>=<span class="hljs-string">"false"</span> <span class="hljs-attr">@error</span>=<span class="hljs-string">"onError"</span> <span class="hljs-attr">:max-size</span>=<span class="hljs-string">"0.5"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">n3-uploader</span>&gt;</span>

<span class="hljs-comment">&lt;!-- click --&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">n3-uploader</span> <span class="hljs-attr">url</span>=<span class="hljs-string">"http://test.com/"</span> <span class="hljs-attr">@error</span>=<span class="hljs-string">"onError"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">n3-uploader</span>&gt;</span>

<span class="hljs-comment">&lt;!-- drag --&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">n3-uploader</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"drag"</span> <span class="hljs-attr">url</span>=<span class="hljs-string">"http://test.com/"</span> <span class="hljs-attr">@error</span>=<span class="hljs-string">"onError"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">n3-uploader</span>&gt;</span>
</code></pre>
<h3>Params</h3>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td>name</td>
<td><code v-pre="">String</code></td>
<td>files</td>
<td>file name</td>
</tr>
<tr>
<td>type</td>
<td><code v-pre="">String</code>：<code v-pre="">click</code> 或 <code v-pre="">drag</code></td>
<td>click</td>
<td>type</td>
</tr>
<tr>
<td>accept</td>
<td><code v-pre="">String</code></td>
<td>'' (accept all)</td>
<td>file type example: <code v-pre="">'image/jpeg'</code> or <code v-pre="">'image'</code>, <code v-pre="">'txt|image|mp3'</code></td>
</tr>
<tr>
<td>url</td>
<td><code v-pre="">String</code></td>
<td></td>
<td>target url</td>
</tr>
<tr>
<td>params</td>
<td><code v-pre="">Object</code></td>
<td></td>
<td>params</td>
</tr>
<tr>
<td>multiple</td>
<td><code v-pre="">Boolean</code></td>
<td>true</td>
<td>accept multiple files</td>
</tr>
<tr>
<td>drag-width</td>
<td><code v-pre="">String</code></td>
<td>300px</td>
<td>width</td>
</tr>
<tr>
<td>drag-height</td>
<td><code v-pre="">String</code></td>
<td>200px</td>
<td>height</td>
</tr>
<tr>
<td>max-length</td>
<td><code v-pre="">Number</code></td>
<td>10</td>
<td>number limit for files</td>
</tr>
<tr>
<td>with-credentials</td>
<td><code v-pre="">Boolean</code></td>
<td>false</td>
<td>cookies support</td>
</tr>
<tr>
<td>max-size</td>
<td><code v-pre="">Number</code></td>
<td>10</td>
<td>size limit of file（MB）</td>
</tr>
</tbody>
</table>
<h3>Events</h3>
<table>
<thead>
<tr>
<th>name</th>
<th>description</th>
<th>params</th>
</tr>
</thead>
<tbody>
<tr>
<td>success</td>
<td>when uploaded mask is done successfully</td>
<td>({response, file})</td>
</tr>
<tr>
<td>finish</td>
<td>when  all masks are finished</td>
<td>()</td>
</tr>
<tr>
<td>delete</td>
<td>when mask is deleted</td>
<td>(uploadItem)</td>
</tr>
<tr>
<td>error</td>
<td>when error occurs</td>
<td>({message, file})</td>
</tr>
</tbody>
</table>
</div>
</template>

</section></template>

<script>

export default {
  data () {
    return {
    }
  },
  methods: {
    onError ({ message, file }) {
      console.error(message, file)
    }
  }
}
</script>


// WEBPACK FOOTER //
// n3UploaderDocs.md?f4499918